var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.5H27.75C28.3023 7.5 28.75 7.94772 28.75 8.5V22.5V27.2919C28.75 27.3758 28.653 27.4224 28.5875 27.37L24.0625 23.75H7.25C6.69772 23.75 6.25 23.3023 6.25 22.75V20",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 2.5H2.25C1.69772 2.5 1.25 2.94772 1.25 3.5V17.5V22.2919C1.25 22.3758 1.34699 22.4224 1.41247 22.37L5.9375 18.75H22.75C23.3023 18.75 23.75 18.3023 23.75 17.75V3.5C23.75 2.94772 23.3023 2.5 22.75 2.5Z",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoMessages);
export default __webpack_public_path__ + "static/media/two-messages.b73402b6f096425e5eea2e9d5dcaacb0.svg";
export { ForwardRef as ReactComponent };